module.exports = __webpack_public_path__ + "img/zmy_web logo@3x.77b4eaa2.png";